function init() {
    scrollToTop();
}

function scrollToTop() { 

    document.addEventListener('facetwp-refresh', ()=>{
        if ( FWP.soft_refresh == true )  {
            FWP.enable_scroll = true;
          } else {
            FWP.enable_scroll = false;
          }
    })

    document.addEventListener('facetwp-loaded', ()=>{
        if (FWP.enable_scroll == true) { 
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    })
   
}

export { init as default }